const servicesDetails = [
  {
    id: 1,
    imageUrl:
      "https://t3.ftcdn.net/jpg/02/14/53/92/360_F_214539232_YnUrtuwUEt84gHuU0qG8l7OwZvH4rnPG.jpg",
    title: "Web Development",
    path: "web-development",
    description:
      "At Work Momentum, we specialize in crafting exceptional web experiences tailored to your unique needs. Our team of experienced web developers utilizes the latest technologies and best practices to create websites that not only look stunning but also perform seamlessly across all devices. From simple static sites to complex web applications, we have the expertise to bring your vision to life. Whether you're looking to launch a new website or revamp an existing one, we're here to help you every step of the way.",
    servicesOffered: [
      {
        name: "Custom Web Development",
        description:
          "We develop customized web applications that meet your specific business requirements, ensuring scalability, security, and user-friendly interfaces.",
        imageUrl:"https://i.postimg.cc/Tw87wTNQ/image.png",
      },
      {
        name: "E-commerce Solutions",
        description:
          "Our e-commerce solutions help businesses establish online stores that are secure, scalable, and optimized for maximum conversion and user experience.",
        imageUrl: "https://i.postimg.cc/26CyJ5M8/images-removebg-preview-1.png",
        },
      {
        name: "Content Management",
        description:
          "We create robust CMS solutions that empower you to manage your website's content efficiently, enhancing flexibility and ease of use.",
        imageUrl:'https://i.postimg.cc/MH6drQ04/image.png',
        },
      {
        name: "Responsive Web Design",
        description:
          "We design websites that adapt seamlessly to various screen sizes and devices, ensuring an optimal user experience across desktops, tablets, and smartphones.",
        imageUrl:'https://www.searchenginejournal.com/wp-content/uploads/2021/10/responsive-web-design-1-61f01c4b64c5f-sej-1280x720.png',
        },
      {
        name: "UI/UX Design and Prototyping",
        description:
          "Our UI/UX design services focus on creating intuitive and visually appealing interfaces that enhance user engagement and satisfaction.",
        imageUrl:"https://blog.eduonix.com/wp-content/uploads/2021/04/Web-Design-Tools-UI-UX-Prototyping-Wireframing.png",
        },
      {
        name: "Maintenance and Support",
        description:
          "We provide ongoing maintenance and support services to ensure your website remains secure, up-to-date, and performing at its best.",
        imageUrl:'https://i.postimg.cc/rF4YF3qy/image.png',
        },
    ],
  },
  {
    id: 2,
    imageUrl:
      "https://t4.ftcdn.net/jpg/02/00/20/89/360_F_200208909_tvpqUno6arZycC8jWtduKEITDcqszvwj.jpg",
    title: "App Development",
    path: "app-development",
    description:
      "Transform your ideas into innovative mobile applications with Work Momentum. Our dedicated team of app developers is passionate about creating user-friendly and feature-rich apps that resonate with your target audience. Whether you're targeting iOS, Android, or cross-platform solutions, we have the skills and experience to build the perfect app for your business. From initial concept to final deployment, we'll work closely with you to ensure your app exceeds your expectations and drives results.",
    servicesOffered: [
      {
        name: "iOS App Development",
        description:
          "We specialize in developing native iOS applications that are tailored to the unique features and guidelines of the Apple ecosystem.",
        imageUrl: "https://www.icoderzsolutions.com/image/benefits-of-ios.webp",
        },
      {
        name: "Android App Development",
        description:
          "Our Android app development services include building native Android applications that offer seamless performance and usability on Android devices.",
        imageUrl:"https://i.postimg.cc/JhCMGNHn/ANDROID-APP-DEVELOPMENT-WITH-MIND-DIGITAL-removebg-preview-1-1.png",
        },
      {
        name: "Cross-Platform App Development",
        description:
          "We leverage cross-platform frameworks like React Native and Flutter to develop apps that run smoothly on both iOS and Android platforms, reducing development time and costs.",
        imageUrl: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQC7U7OGYl3NQVVwivKsuIufOo6MB24ga1q5A&usqp=CAU",
        },
      {
        name: "Mobile App UI/UX Design",
        description:
          "We design intuitive and user-friendly interfaces for mobile apps that enhance usability, engage users, and align with your brand's identity.",
        imageUrl:"https://i.postimg.cc/pXGXs5hV/How-Important-is-UI-UX-Design-in-an-App-Development-Process-removebg-preview.png",
        },
      {
        name: "App Maintenance and Support",
        description:
          "We provide comprehensive app maintenance and support services to ensure your mobile application remains secure, updated, and fully functional.",
        imageUrl: "https://techexactly.com/wp-content/uploads/2024/05/Mobile-App-Maintenance-Services.svg",
        },
      {
        name: "App Testing and QA",
        description:
          "Our rigorous testing and quality assurance processes help identify and eliminate bugs, ensuring your app delivers a seamless user experience.",
        imageUrl:" https://i.postimg.cc/MHdh5RGy/image-removebg-preview.png",
        },
    ],
  },
  {
    id: 3,
    imageUrl:
      "https://t3.ftcdn.net/jpg/04/82/07/90/360_F_482079087_jTfhGFhJgMeWt40zI9qhgjTQX7zXtLd0.jpg",
    title: "Cloud & DevOps",
    path: "cloud-devops",
    description:
      "Harness the power of the cloud with Work Momentum's AWS and DevOps services. Our team of certified AWS experts can help you leverage Amazon Web Services to build scalable, secure, and reliable cloud solutions that meet your business needs. Whether you're looking to migrate to the cloud, optimize your existing AWS infrastructure, or implement DevOps best practices, we've got you covered. With our expertise in automation, continuous integration, and continuous delivery, we'll streamline your development process and accelerate your time to market. Let us be your trusted partner in the cloud journey.",
    servicesOffered: [
      {
        name: "AWS Cloud Consulting",
        description:
          "We offer expert guidance and consulting services to help businesses leverage AWS cloud solutions for their specific needs and objectives.",
        imageUrl:"https://i.postimg.cc/jqf6fN5f/image.png",
        },
      {
        name: "AWS Architecture",
        description:
          "Our AWS architects design and implement scalable and cost-effective cloud architectures that optimize performance and reliability.",
        imageUrl:"https://images.edrawmax.com/images/how-to/create-aws-architecture-in-visio/aws-components.png",
        },
      {
        name: "Cloud Migration Services",
        description:
          "We assist businesses in migrating their applications and data to AWS cloud, ensuring a seamless transition with minimal disruption.",
        imageUrl:"https://i.postimg.cc/C1S3TYzM/image.png",
        },
      {
        name: "DevOps Automation and Integration",
        description:
          "We implement DevOps practices and automation tools to streamline development, testing, and deployment processes, improving efficiency and collaboration.",
        imageUrl:"https://i.postimg.cc/gkr8Mwqz/image-removebg-preview-2.png",
        },
      {
        name: "Continuous Integration Delivery (CI/CD)",
        description:
          "We implement CI/CD pipelines to automate and accelerate software delivery, ensuring faster time-to-market and higher-quality releases.",
        imageUrl:"https://i.postimg.cc/G3KQ28jr/360-F-557718864-Exr-KV8hwn-Ytji-ISUhhc-DGfe-PXs4-Dl-FDt-removebg-preview.png",
        },
      {
        name: "Infrastructure as Code (IaC)",
        description:
          "We use Infrastructure as Code (IaC) tools like Terraform and CloudFormation to provision and manage cloud resources efficiently and consistently.",
        imageUrl:"https://i.postimg.cc/XNcXw9ZG/Ia-C-1500x1500-removebg-preview.png",
        },
    ],
  },
];

function ServicesInfo() {
  return servicesDetails;
}

export default ServicesInfo;
